const Modal = {
   defaultProps: {
      size: '2xl',
   },
};

export default Modal;
